import { LabelValueSet } from "../../utility/LabelValueSet";

export enum UserAccountRole {
    CLIENT = "CLIENT",
    OPERATOR = "OPERATOR",
    ADMINISTRATOR = "ADMINISTRATOR"
}

export const userAccountRoleList: LabelValueSet[] = [
    new LabelValueSet("家族", UserAccountRole.CLIENT),
    new LabelValueSet("事業者", UserAccountRole.OPERATOR),
    new LabelValueSet("管理者", UserAccountRole.ADMINISTRATOR)
];

export const getUserAccountRoleFromValue = (value: string): UserAccountRole => {
    switch (value.toUpperCase()) {
        case "ADMINISTRATOR": {
            return UserAccountRole.ADMINISTRATOR;
        }
        case "OPERATOR": {
            return UserAccountRole.OPERATOR;
        }
        default: {
            return UserAccountRole.CLIENT;
        }
    }
};

export const getLabelFromUserAccountRole = (role: UserAccountRole): string =>{
    switch (role) {
        case UserAccountRole.ADMINISTRATOR: {
            return "管理者";
        }
        case UserAccountRole.OPERATOR: {
            return "事業者";
        }
        default: {
            return "家族";
        }
    }
};
